<div class="notification-panel" [style.display]="showNotification ?  'block' : 'none'">
    <!--  <div class="notification-panel-header">
         <div class="unread-count">Un read ({{unreadCount}})</div> 
        <a *ngIf="notifications.length>0" (click)="clearAll()">clear all</a>
    </div>-->
    <div class="notification-panel-header">
        <h2>Notifications</h2>
        <button (click)="closeNotifications()" ngbTooltip="Close" aria-label="Close" class="icon icon-cira clear-text"></button>
    </div>
    <div class="tabset">
        <div class="tabs">
            <ul>
                <li [activeTab]="'info'" [class.active]="activeTab === 'info'" (click)="tabChange('info')">Info</li>
                <li [activeTab]="'progress-bar'" [class.active]="activeTab === 'progress-bar'" (click)="tabChange('progress-bar')">Progress</li>
                <li [activeTab]="'alerts'" [class.active]="activeTab === 'alerts'" (click)="tabChange('alerts')">Alerts</li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="info-content" *ngIf="activeTab === 'info'">
                <span class="n-noti" *ngIf="(notifications.length== 0)">You have no new Notifications</span>
                <div class="not-body" *ngIf="notifications.length">
                    <ng-scrollbar class="d-scroll" #scrollRef>
                        <div class="notifications" *ngFor="let notification of notifications">
            
                            <!-- notificaion item-->
                            <div class="not-box">
                                <div class="left" (click)="navigate(notification)">
                                    <div class="not-cat">
                                        <span [ngClass]="(notification.type=='project')?'iconset2-proj-alert':'iconB-account-alert'"></span>
                                    </div>
                                    <div class="not-det">
                                        <h3>{{notification.title}}</h3>
                                        <p>{{notification.body}}</p>
                                    </div>
                                </div>
                                <div class="right">
                                    <div class="date-time-wrap">
                                        <span class="date">{{notification.timestamp | date: _vaService?.activeAgent?.date_format ? _vaService?.activeAgent?.date_format : 'mediumDate'}}</span>
                                        <span class="time">{{notification.timestamp | date: 'h:mm a'}}</span>
                                    </div>
                                    <button (click)="clear(notification._id)" aria-label="Close" ngbTooltip="Close" class="icon icon-cira"></button>
                                </div>
                            </div>
                            <!-- notificaion End-->
            
                            <!--  <div class="notification" *ngFor="let notification of notifications">
                                    <div class="notification-panel-header">
                                       <span></span> <i>{{notification.timestamp | date: 'yyyy/MM/dd h:mm:ss a'}}</i>
                                        <span class="date">{{notification.timestamp | date: 'MMM d, y'}}</span>
                                        <span class="time">{{notification.timestamp | date: 'h:mm a'}}</span>
                        
                                    </div> -->
                            <!-- <p>{{notification.body}}<br><a *ngIf="!notification.read" (click)="markAsRead(notification._id);notification.read=true">mark as read</a></p> 
                            </div>-->
            
                        </div>
                        <button *ngIf=" loadMoreFalg" class="load-more" (click)="loadMore()">Load more</button>
                    </ng-scrollbar>
            
                </div>
            
            
                <div class="footer">
                    <!-- <button>Mark all as read</button>
                    <button>Clear All</button> -->
                    <a *ngIf="notifications.length>0" (click)="clear()">clear all</a>
                    <!-- <a *ngIf="!notification.read" (click)="markAsRead(notification._id);notification.read=true">Mark all as read</a> -->
                </div>
            </div>
            <div class="content" *ngIf="activeTab === 'progress-bar'">
                <div *ngIf="progessList.length" class="progress-bar-content">
                    <div class="progress-notifications">
                        <app-progress-bar *ngFor="let progess of progessList" [progress]=progess></app-progress-bar>
                    </div>
                    <div class="d-flex justify-content-end px-4 pb-0">
                        <a *ngIf="progessList.length>0" (click)="clearProgress()">clear all</a>
                    </div>
                </div>
                <div *ngIf="progessList.length == '0'">
                    <span class="no-alert">You have no long running activities to show</span>
                </div>
            </div>
            <div class="content" *ngIf="activeTab === 'alerts'">
                <span class="no-alert" *ngIf="!deployment_running && !duplicateDocStatus">You have no new Alerts</span>
                <div class="alert-content" [ngStyle]="{display: !deployment_running && !duplicateDocStatus? 'none' : 'block'}">
                    <div class="general-popup red mb-2" *ngIf="deployment_running">
                        <span class="icon-topic-warnning"></span>
                        <p class="mb-0"> {{deployment_message}}</p>
                    </div>
                    <div class="duplicateDoc" *ngIf="duplicateDocStatus">
                        <div class="title">
                            <span class="icon-topic-warnning"></span>
                            <p>Duplicate content found in the following documents during the training.</p>
                            <div class="dateTime">{{ formattedDate }}</div>
                        </div>
                        <div *ngFor="let pairs of similarPairs">
                            <div class="pair">
                                <div *ngFor="let item of pairs">
                                    <span class="iconB-file-text"></span>
                                    {{item}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer mr-3">
                    <a *ngIf="notifications.length>0" (click)="duplicateDocStatus = false; deployment_running = false">clear all</a>
                </div>
            </div>
        </div>
    </div>
</div>